// ============================================================
// sale-content/ContentItemList.js — รายการเนื้อหาของ 1 section (ยกเว้นภาพพื้นหลัง)
// ------------------------------------------------------------
// เรียงตาม sequence (ลำดับเดียวกับบนหน้าเว็บ) · เลื่อนขึ้น/ลง · เปิด-ปิด · แก้ไข · ลบ
// ★ section แบบ single (พาดหัว / แถบชวนติดต่อ / ฟุตเตอร์) หน้าเว็บหยิบแค่ "ชิ้นแรกที่เปิดแสดง"
//   ชิ้นอื่นที่เหลือจึงติดป้าย "ไม่ถูกใช้" ให้เห็นชัด ไม่งั้นแก้ไปแล้วงงว่าทำไมเว็บไม่เปลี่ยน
// ============================================================

import React from "react";
import { summarize } from "./sections.js";

export default function ContentItemList({ section, items = [], working, onEdit, onToggle, onMove, onDelete }) {
  const firstActiveUid = section.single ? items.find((i) => i.is_active)?.uid : null;

  return (
    <div className="sc-list">
      {items.map((item, index) => {
        const sum = summarize(section.key, item);
        const busy = !!working;
        const unused = section.single && item.is_active && item.uid !== firstActiveUid;

        return (
          <div key={item.uid} className={`sc-item ${item.is_active ? "" : "is-off"}`} data-testid={`sc-item-${section.key}`}>
            <div className="sc-item__no">{index + 1}</div>

            {!!sum.image && <img className="sc-item__thumb" src={sum.image} alt="" />}
            {!!sum.icon && <span className="sc-item__icon icon">{sum.icon}</span>}
            {!!sum.big && <span className="sc-item__big">{sum.big}</span>}

            <div className="sc-item__body">
              {!!sum.kicker && <div className="text-12 text-secondary">{sum.kicker}</div>}
              <div className="fw-bold text-truncate">{sum.title || (sum.big ? "" : "-")}</div>
              {!!sum.sub && <div className="text-12 text-secondary sc-item__sub">{sum.sub}</div>}
              <div className="d-flex flex-wrap gap-1 mt-1">
                <span className={`sc-badge ${item.is_active ? "sc-badge--on" : ""}`}>{item.is_active ? "แสดงบนเว็บ" : "ซ่อนอยู่"}</span>
                {section.single && item.uid === firstActiveUid && <span className="sc-badge sc-badge--use">ชิ้นที่หน้าเว็บใช้</span>}
                {unused && <span className="sc-badge sc-badge--warn">ไม่ถูกใช้ (เว็บใช้แค่ชิ้นแรก)</span>}
              </div>
            </div>

            <div className="sc-item__actions">
              <button
                type="button"
                className="prop-btn prop-btn--ghost prop-btn--sm"
                title="เลื่อนขึ้น"
                disabled={index === 0 || busy}
                onClick={() => onMove(index, -1)}
              >
                <span className="icon">{""}</span>
              </button>
              <button
                type="button"
                className="prop-btn prop-btn--ghost prop-btn--sm"
                title="เลื่อนลง"
                disabled={index === items.length - 1 || busy}
                onClick={() => onMove(index, 1)}
              >
                <span className="icon">{""}</span>
              </button>
              <button
                type="button"
                className="prop-btn prop-btn--ghost prop-btn--sm"
                disabled={busy}
                onClick={() => onToggle(item)}
              >
                {item.is_active ? "ซ่อน" : "แสดง"}
              </button>
              <button type="button" className="prop-btn prop-btn--sm" disabled={busy} onClick={() => onEdit(item)}>
                แก้ไข
              </button>
              <button type="button" className="prop-btn prop-btn--danger prop-btn--sm" disabled={busy} onClick={() => onDelete(item)}>
                ลบ
              </button>
            </div>
          </div>
        );
      })}
    </div>
  );
}
